import { Component, inject, OnInit } from '@angular/core';
import { OvertimeWidgetComponent } from './components/widgets/overtime-widget/overtime-widget.component';
import { KilometersDrivenWidgetComponent } from '../overview/components/widgets/kilometers-driven-widget/kilometers-driven-widget.component';
import { AccountFilterComponent } from '../../_shared/components';
import { AccountFilterData, WidgetFilterData } from '../../_shared/models';
import { AuthService, FilterService } from '../../_shared/services';
import { TripsWidgetComponent } from './components/widgets/trips-widget/trips-widget.component';
import { isEmptyObject } from '../../_shared/helpers/object.helper';
import { RouterModule } from '@angular/router';
import { DriverPerformanceWidgetComponent } from './components/widgets/driver-performance-widget/driver-performance-widget.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-overview',
  standalone: true,
  imports: [
    TripsWidgetComponent,
    OvertimeWidgetComponent,
    KilometersDrivenWidgetComponent,
    DriverPerformanceWidgetComponent,
    AccountFilterComponent,
    RouterModule,
    TranslocoDirective
  ],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
})
export class OverviewComponent implements OnInit {

  accountFilter: AccountFilterData;
  private refreshIntervalId: any;

  private filterService = inject(FilterService);
  private auth = inject(AuthService);

  ngOnInit(): void {
    this.accountFilter = {} as AccountFilterData;
    const refreshTime = this.auth.getUserSettings()?.dashboardRefreshTime;
    if (refreshTime) {
      this.startRefreshInterval(refreshTime);
    }
  }

  onAccountFilterChange(filterData: AccountFilterData) {
    this.accountFilter = filterData;
    this.updateFilter();
  }

  updateFilter(): void {
    if (!isEmptyObject(this.accountFilter)) {
      this.filterService.updateFilter({
        ...this.accountFilter
      } as WidgetFilterData);
    }
  }

  private startRefreshInterval(seconds: number) {
    this.refreshIntervalId = setInterval(() => {
      this.onAccountFilterChange(this.accountFilter);
    }, seconds * 1000);
  }

  ngOnDestroy(): void {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }
}